/**
 * A Thread version, `ThreadEntryRef` `<thread id>#<number>` (threads.md, Concepts): the path
 * up to that entry. Because the log only grows, it never changes, so it is what people copy
 * to cite a Thread (FR-THREAD-8, NFR-16).
 */
export interface ThreadEntryRef {
  readonly threadId: string;
  readonly number: number;
}

const ENTRY_SEPARATOR = "#";

export function formatThreadEntryRef(reference: ThreadEntryRef): string {
  return `${reference.threadId}${ENTRY_SEPARATOR}${String(reference.number)}`;
}

/** Read `<thread id>#<number>`; `null` for anything else. The server checks the ID itself. */
export function parseThreadEntryRef(text: string): ThreadEntryRef | null {
  const parts = text.trim().split(ENTRY_SEPARATOR);
  if (parts.length !== 2) {
    return null;
  }
  const [threadId, numberText] = parts as [string, string];
  if (threadId === "" || /\s/.test(threadId) || !/^[1-9][0-9]{0,8}$/.test(numberText)) {
    return null;
  }
  return { threadId, number: Number(numberText) };
}
